<template>
  <div class="h-16 px-4 mx-auto lg:px-6">
    <div class="flex justify-between">
      <div class="flex items-center w-full lg:justify-between">
        <div class="flex items-stretch shrink-0">
          <div class="flex items-center mr-4 lg:hidden">
            <button
              type="button"
              class="z-10 inline-flex items-center justify-center p-4 -mx-4 focus:outline-none"
              aria-controls="mobile-menu"
              aria-expanded="false"
              @click="$emit('openMobile')"
            >
              <span class="sr-only">Open main menu</span>
              <BurgerIcon class="size-6 text-burnt-sienna" />
            </button>
          </div>
          <a href="https://pastaevangelists.com/" aria-label="Go to homepage" class="-mt-0.5">
            <ThePastaLogo class="h-auto py-4 cursor-pointer w-[100px] text-terracota-dark" />
          </a>
          <div v-if="!hideToggle" class="hidden ml-12 space-x-8 lg:flex">
            <div class="relative flex items-center justify-center h-full">
              <div id="menuTW_header_TWtoggle" class="text-terracota-dark">Takeaway</div>
              <div class="absolute -bottom-px self-center w-8 h-0.5 bg-terracota-dark" />
            </div>

            <div class="relative flex items-center h-full group">
              <router-link
                id="menuTW_header_RKtoggle"
                :to="{ name: 'product-box' }"
                class="text-burnt-sienna group-hover:text-terracota-dark"
              >
                Recipe kits
              </router-link>
              <div
                class="absolute hidden group-hover:block -bottom-px left-5 self-center w-8 h-0.5 bg-burnt-sienna"
              />
            </div>
          </div>
        </div>
        <div class="relative items-center hidden h-full lg:space-x-6 lg:-my-px lg:flex group">
          <router-link v-if="!isLoggedIn" id="menuTW_header_Login" to="/social-login">
            <div class="p-1 rounded-full bg-sandstone">
              <UserIcon class="size-8 text-burnt-sienna group-hover:text-terracota-dark" />
            </div>
          </router-link>

          <router-link v-else id="menuTW_header_Account" to="/account">
            <div class="p-1 rounded-full bg-sandstone">
              <UserIcon class="size-8 text-burnt-sienna group-hover:text-terracota-dark" />
            </div>
          </router-link>
          <div
            class="absolute hidden group-hover:block -bottom-px -left-5 w-8 h-0.5 bg-burnt-sienna"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import ThePastaLogo from '@/components/ThePastaLogo.vue';

  interface Props {
    isLoggedIn?: boolean;
    hideToggle?: boolean;
  }

  interface Emits {
    (e: 'openMobile'): void;
    (e: 'logout'): void;
  }

  defineProps<Props>();
  defineEmits<Emits>();
</script>
